import React from 'react';
import BellIcon from './12-14-bell.svg';
// SIDEBAR ICONS
import CheckedIcon from './20-checked.svg';
import ChevronForwardIcon from './20-chevron-right.svg';
import ChevronIcon from './20-chevron.svg';
import ClaiEmblemBlackIcon from './20-clai-black.svg';
import ClaiEmblemIcon from './20-clai.svg';
import CloseIcon from './20-close.svg';
import ClaiEmblemFilledIcon from './20-colored-clai-logo.svg';
import ColoredDocIcon from './20-colored-doc.svg';
import MoneyIconSvg from './20-currency-coin-dollar.svg';
import DealsIcon from './20-deals.svg';
import TemplateIcon from './20-doc.svg';
import FilterIcon from './20-filter.svg';
import FolderIcon from './20-folder.svg';
import HomeIcon from './20-home.svg';
import InfoIcon from './20-information-circle-contained.svg';
import MoreIcon from './20-more.svg';
import PlusDarkIcon from './20-plus-dark.svg';
import PlusWhiteIcon from './20-plus-white.svg';
import SearchWhiteIconSvg from './20-search-white.svg';
import SearchIcon from './20-search.svg';
import SettingsGearIcon from './20-settings-gear.svg';
import SidebarIcon from './20-sidebar.svg';
import SignaturesIcon from './20-signature.svg';
import UploadGreenIcon from './20-upload-green.svg';
import PeopleIcon from './20-user.svg';
import AddIcon from './32-add.svg';
import AvatarBlueIcon from './avatar-blue.svg';
// SOON TO BE DEPRECATED ICONS / WILL BE PHASED OUT

import AvatarIcon from './avatar.svg';
import CheckmarkIcon from './checkmark.svg';
import ClaiLogoIcon from './clai-logo.svg';
import DocumentIcon from './doc.svg';
import FieldsIcon from './fields.svg';
import FileIcon from './file.svg';
import FormIcon from './form.svg';
import InboxIcon from './inbox.svg';
import LandlordIcon from './landlord.svg';
import LeaseIcon from './lease.svg';
import LinkedinIcon from './linkedin.svg';
import LogoIcon from './logo.svg';
import BothIcon from './parties.svg';
import PurchaseIcon from './purchase.svg';
import SavedSnipIcon from './saved-snip.svg';
import SignatureIcon from './signature.svg';
import SignerIcon from './signer.svg';
import SpaceInsightsIcon from './space-insights.svg';
import { SpinnerGradientIcon } from './spinner-gradient';
import StarIcon from './star.svg';
import TenantIcon from './tenant.svg';
import DocTypeIcon from './type-doc.svg';
import UploadIcon from './upload.svg';
import DealsSkeuomorphicIcon from './w-40-deals-skeuomorphic.svg';
import LeaseSkeuomorphicIcon from './w-40-lease-skeuomorphic.svg';
import PurchaseSkeuomorphicIcon from './w-40-purchase-skeuomorphic.svg';

// Sidebar Exports

export const ClaiEmblem = ClaiEmblemIcon;
export const ClaiEmblemBlack = ClaiEmblemBlackIcon;
export const ClaiEmblemIconFilled = ClaiEmblemFilledIcon;
export const Home = HomeIcon;
export const Folder = FolderIcon;
export const Deals = DealsIcon;
export const Money = MoneyIconSvg;
export const Template = TemplateIcon;
export const Workflows = TemplateIcon;
export const People = PeopleIcon;
export const Signatures = SignaturesIcon;
export const Chevron = ChevronIcon;
export const ChevronForward = ChevronForwardIcon;
export const Search = SearchIcon;
export const SearchWhite = SearchWhiteIconSvg;
export const SearchWhiteIcon = SearchWhiteIconSvg;
export const PlusDark = PlusDarkIcon;
export const PlusWhite = PlusWhiteIcon;
export const Add = AddIcon;
export const Sidebar = SidebarIcon;
export const Filter = FilterIcon;
export const More = MoreIcon;
export const DealsSkeuomorphic = DealsSkeuomorphicIcon;
export const LeaseSkeuomorphic = LeaseSkeuomorphicIcon;
export const PurchaseSkeuomorphic = PurchaseSkeuomorphicIcon;
export const Checked = CheckedIcon;
export const Close = CloseIcon;
export const Info = InfoIcon;
export const ColoredDoc = ColoredDocIcon;
export { ColoredDocIcon };

// SOON TO BE DEPRECATED ICONS / WILL BE PHASED OUT

export const Inbox = InboxIcon;
export const File = FileIcon;
export const Logo = LogoIcon;

// Wrapper component to support fill prop for background color customization
const DefaultAvatarWrapper = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(({
  fill,
  style,
  ...props
}, ref) => {
  return <AvatarIcon ref={ref} {...props} style={{
    color: fill ?? '#FFB7A1',
    ...style
  }} />;
});
DefaultAvatarWrapper.displayName = 'DefaultAvatar';
export const DefaultAvatar = DefaultAvatarWrapper;
export const Lease = LeaseIcon;
export const Purchase = PurchaseIcon;
export const Landlord = LandlordIcon;
export const Tenant = TenantIcon;
export const Both = BothIcon;
export const Document = DocumentIcon;
export const Upload = UploadIcon;
export const UploadGreen = UploadGreenIcon;
export const Signer = SignerIcon;
export const SpaceInsights = SpaceInsightsIcon;
export const SavedSnip = SavedSnipIcon;
export const Fields = FieldsIcon;
export const Form = FormIcon;
export const Star = StarIcon;
export const AvatarBlue = AvatarBlueIcon;
export const ClaiLogo = ClaiLogoIcon;
export const Signature = SignatureIcon;
export const Linkedin = LinkedinIcon;
export const Checkmark = CheckmarkIcon;
export const SpinnerGradient = SpinnerGradientIcon;
export const SettingsGear = SettingsGearIcon;
export const Bell = BellIcon;
export const DocType = DocTypeIcon;